import React, { MouseEvent } from 'react';
import Link from 'atomic/utilization/link';
import AttributesInterface from 'interfaces/attributes.interface';

import './product-attributes-list.scss';

interface ProductAttributesProps {
    slice?: number;
    attributes: AttributesInterface[];
    onMore?: () => void;
}

const ProductAttributesList: React.FC<ProductAttributesProps> = props => {
    const ScrollToAttributes = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        e.preventDefault();

        const attributesDiv = document.getElementById('attributes');

        if (props.onMore) {
            props.onMore();
        }

        if (attributesDiv) {
            location.hash = '#techniczne';

            setTimeout(() => {
                attributesDiv.scrollIntoView({ behavior: 'smooth' });
            }, 0);
        }
    };

    return (
        <ul className="product-attributes">
            {props.attributes.slice(0, props.slice || 3).map(attr => (
                <li className="product-attributes__item" key={attr.label}>
                    <span>
                        {attr.label}
                        :&nbsp;
                    </span>
                    {attr.value}
                </li>
            ))}
            {props.attributes.length > 3 && (
                <li className="product-attributes__more">
                    <Link href="#techniczne" className="link gtm_gpar" title="Zobacz więcej parametrów"
                        onClick={ScrollToAttributes}
                    >
                        Więcej&nbsp;parametrów
                    </Link>
                </li>
            )}
        </ul>
    );
};

export default ProductAttributesList;
